import { render, staticRenderFns } from "./ProfileVisibility.vue?vue&type=template&id=2b153a86"
import script from "./ProfileVisibility.vue?vue&type=script&lang=js"
export * from "./ProfileVisibility.vue?vue&type=script&lang=js"
import style0 from "./ProfileVisibility.vue?vue&type=style&index=0&id=2b153a86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports